import { useIntl } from '@weenat/wintl'
import useDisclosure from 'app/src/hooks/useDisclosure'
import Icons from 'app/src/kit/Icons'
import Modal from 'app/src/kit/Modal'
import TextTooltip from 'app/src/kit/tooltips/TextTooltip'
import { GoogleMapApi } from 'app/src/map/utils'
import { useTheme } from 'styled-components'
import logEvent from '../../../../../utils/analytics'
import ControlsContainer from '../ControlsContainer'
import {
  useBackgroundMapContext,
  useBackgroundMapDispatcher
} from '../contexts/BackgroundMapContext'
import RadarLegend from './RadarLegend'
import RadarSlider from './RadarSlider'
import useIsRadarEnabled from './hooks/useIsRadarEnabled'

const Radar = ({ map, maps }: GoogleMapApi) => {
  const { t } = useIntl()
  const { colors } = useTheme()

  const [isRadarEnabled, setIsRadarEnabled] = useIsRadarEnabled()

  const { drawMarkers } = useBackgroundMapContext()
  const dispatch = useBackgroundMapDispatcher()

  const { isOpen: isLegendOpen, close: closeLegend, open: openLegend } = useDisclosure()

  return isRadarEnabled ? (
    <>
      <Flex $flex={1} $alignItems='flex-end' $gap='lg'>
        <RadarSlider map={map} maps={maps} />
        <Flex $flexDirection='column' $gap='md'>
          <ControlsContainer>
            {drawMarkers ? (
              <Icons.LocationOn
                $rounded
                $size={'lg'}
                onPress={() => {
                  dispatch({ type: 'setUserMarkersVisibility', visible: false })
                }}
              />
            ) : (
              <Icons.LocationOff
                $rounded
                $size={'lg'}
                onPress={() => {
                  dispatch({ type: 'setUserMarkersVisibility', visible: true })
                }}
              />
            )}
          </ControlsContainer>
          <ControlsContainer>
            <Icons.InfoCircle $rounded $size={'lg'} onPress={() => openLegend()} />
          </ControlsContainer>
          <ControlsContainer>
            <Icons.Close
              $rounded
              $size={'lg'}
              onPress={() => {
                logEvent('radar_close')
                setIsRadarEnabled(false)
              }}
            />
          </ControlsContainer>
        </Flex>
      </Flex>
      <Modal isOpen={isLegendOpen} close={closeLegend} title={t('help.legend')}>
        <RadarLegend />
      </Modal>
    </>
  ) : (
    <TextTooltip
      content={t('map_settings.view.options.radar', { capitalize: true })}
      placement='left'
    >
      <ControlsContainer>
        <Icons.Radar
          $size={'xl'}
          $m={'sm'}
          onPress={() => {
            logEvent('radar_open')
            setIsRadarEnabled(true)
          }}
          $color={isRadarEnabled ? 'primary.500' : colors.grayscale.black}
        />
      </ControlsContainer>
    </TextTooltip>
  )
}

export default Radar
